var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('h3',{staticClass:"ul-widget__head-title"},[_vm._v("Commissions")]),_c('b-card-body',[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"300"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }